import { Params, useParams } from 'react-router-dom';

const useCustomParams = (): Readonly<Params<string>> => {
	const params = useParams();
	const updateParams = { ...params };

	updateParams.partner = updateParams.partner ?? (process.env.DEFAULT_PARTNER as string);

	return updateParams;
};

export default useCustomParams;
